module.exports = __webpack_public_path__ + "img/backyard-side-door.1de87e5f.jpg";